(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paintli-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-plh-acc]').forEach((button) => {
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.hidden = expanded;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paintli-footer"] && !Shopify.designMode) return;
  try {
    
  const form = document.getElementById('PaintliFooterLocalization');
  if (form) {
    form.querySelectorAll('select').forEach((select) => {
      select.addEventListener('change', () => form.submit());
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paintli-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pl-gallery]').forEach((gallery) => {
    const slides = gallery.querySelectorAll('[data-pl-slide]');
    const thumbs = gallery.querySelectorAll('[data-pl-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = thumb.getAttribute('data-pl-thumb');
        slides.forEach((slide) => {
          const active = slide.getAttribute('data-pl-slide') === index;
          slide.classList.toggle('is-active', active);
          slide.hidden = !active;
        });
        thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });
  });

  const qtyInput = document.getElementById('PaintliOfferQty');
  const stickyPriceEls = document.querySelectorAll('[data-pl-sticky-price]');
  document.querySelectorAll('[data-pl-offer-qty]').forEach((input) => {
    input.addEventListener('change', () => {
      if (!input.checked) return;
      if (qtyInput) qtyInput.value = input.getAttribute('data-pl-offer-qty') || '1';
      const price = input.getAttribute('data-pl-offer-price');
      if (price) stickyPriceEls.forEach((el) => { el.textContent = price; });
      document.querySelectorAll('.pl-offer').forEach((offer) => {
        offer.classList.toggle('is-selected', offer.contains(input));
      });
    });
  });

  (() => {
    const sticky = document.querySelector('[data-pl-sticky]');
    const countEl = sticky?.querySelector('[data-pl-sticky-cart-count]');
    if (!sticky) return;

    const setVisible = (visible) => {
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    const syncVisibility = () => {
      setVisible(window.matchMedia('(max-width: 989px)').matches);
    };

    syncVisibility();
    window.matchMedia('(max-width: 989px)').addEventListener('change', syncVisibility);

    const syncCount = (count) => {
      if (!(countEl instanceof HTMLElement)) return;
      const next = Math.max(0, Number(count) || 0);
      countEl.textContent = String(next);
      countEl.classList.toggle('is-empty', next === 0);
    };

    document.addEventListener('shopify:cart:lines-update', (event) => {
      const detail = event?.detail;
      const count = detail?.itemCount ?? detail?.cart?.totalQuantity ?? detail?.cart?.item_count;
      if (count != null) syncCount(count);
    });

    fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
      .then((r) => r.json())
      .then((cart) => syncCount(cart.item_count))
      .catch(() => {});
  })();

  (() => {
    const bar = document.querySelector('[data-pl-offerbar]');
    if (!bar) return;
    const key = 'paintli-offerbar-dismissed';
    if (sessionStorage.getItem(key) === '1') {
      bar.remove();
      return;
    }
    bar.hidden = false;
    bar.querySelector('[data-pl-offerbar-close]')?.addEventListener('click', () => {
      sessionStorage.setItem(key, '1');
      bar.remove();
    });

    const timer = bar.querySelector('[data-pl-timer]');
    if (!timer) return;
    const hours = Math.max(1, Number(timer.getAttribute('data-pl-timer-hours') || 2));
    const endKey = 'paintli-offerbar-end';
    let end = Number(sessionStorage.getItem(endKey) || 0);
    const now = Date.now();
    if (!end || end <= now) {
      end = now + hours * 60 * 60 * 1000;
      sessionStorage.setItem(endKey, String(end));
    }
    const hEl = timer.querySelector('[data-pl-timer-h]');
    const mEl = timer.querySelector('[data-pl-timer-m]');
    const sEl = timer.querySelector('[data-pl-timer-s]');
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let left = Math.max(0, end - Date.now());
      if (left === 0) {
        end = Date.now() + hours * 60 * 60 * 1000;
        sessionStorage.setItem(endKey, String(end));
        left = end - Date.now();
      }
      const total = Math.floor(left / 1000);
      const h = Math.floor(total / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    };
    tick();
    setInterval(tick, 1000);
  })();

  document.querySelectorAll('[data-pl-seen]').forEach((root) => {
    const cards = root.querySelectorAll('[data-pl-seen-card]');
    cards.forEach((card) => {
      const video = card.querySelector('.pl-seen__video');
      if (!video) return;
      card.addEventListener('click', () => {
        const playing = card.classList.contains('is-playing');
        cards.forEach((other) => {
          const otherVideo = other.querySelector('.pl-seen__video');
          other.classList.remove('is-playing');
          if (otherVideo) {
            otherVideo.pause();
            otherVideo.currentTime = 0;
          }
        });
        if (playing) return;
        card.classList.add('is-playing');
        video.muted = true;
        video.play().catch(() => {
          card.classList.remove('is-playing');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paintli-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-pl-reviews]');
    if (!root) return;

    const track = root.querySelector('[data-pl-reviews-track]');
    const viewport = root.querySelector('[data-pl-reviews-viewport]');
    const slides = [...root.querySelectorAll('[data-pl-reviews-slide]')];
    const prev = root.querySelector('[data-pl-reviews-prev]');
    const next = root.querySelector('[data-pl-reviews-next]');
    const progress = root.querySelector('[data-pl-reviews-progress]');
    if (!track || !viewport || slides.length === 0) return;

    let index = 0;

    const perView = () => {
      const w = window.innerWidth;
      if (w >= 1024) return Math.min(3, slides.length);
      if (w >= 750) return Math.min(2, slides.length);
      return 1;
    };

    const maxIndex = () => Math.max(0, slides.length - perView());

    const gap = () => {
      const style = getComputedStyle(track);
      return parseFloat(style.columnGap || style.gap) || 0;
    };

    const go = (nextIndex) => {
      index = Math.max(0, Math.min(nextIndex, maxIndex()));
      const slideW = slides[0].getBoundingClientRect().width;
      const offset = index * (slideW + gap());
      track.style.transform = `translate3d(${-offset}px, 0, 0)`;

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      if (progress) {
        const steps = Math.max(1, maxIndex() + 1);
        progress.style.transform = `scaleX(${(index + 1) / steps})`;
      }

      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex();
    };

    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    window.addEventListener('resize', () => go(index));
    go(0);

    root.querySelectorAll('[data-pl-review-photos]').forEach((media) => {
      const photos = [...media.querySelectorAll('.pl-reviews__photo')];
      const dots = [...media.querySelectorAll('[data-pl-photo-dot]')];
      if (photos.length < 2) return;
      let photoIndex = 0;

      const showPhoto = (nextPhoto) => {
        photoIndex = (nextPhoto + photos.length) % photos.length;
        photos.forEach((photo, i) => photo.classList.toggle('is-active', i === photoIndex));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === photoIndex));
      };

      media.querySelector('[data-pl-photo-prev]')?.addEventListener('click', (e) => {
        e.stopPropagation();
        showPhoto(photoIndex - 1);
      });
      media.querySelector('[data-pl-photo-next]')?.addEventListener('click', (e) => {
        e.stopPropagation();
        showPhoto(photoIndex + 1);
      });
      dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          showPhoto(Number(dot.getAttribute('data-pl-photo-dot')) || 0);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paintli-pdp-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-pl-features]');
    if (!root) return;

    const slides = [...root.querySelectorAll('[data-pl-features-slide]')];
    const controls = root.querySelector('[data-pl-features-controls]');
    if (!controls || slides.length < 2) return;

    const currentEl = root.querySelector('[data-pl-features-current]');
    const prev = root.querySelector('[data-pl-features-prev]');
    const next = root.querySelector('[data-pl-features-next]');
    let index = 0;

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      if (currentEl) currentEl.textContent = String(index + 1);
    };

    prev?.addEventListener('click', () => {
      if (!isMobile()) return;
      show(index - 1);
    });
    next?.addEventListener('click', () => {
      if (!isMobile()) return;
      show(index + 1);
    });

    show(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paintli-results"] && !Shopify.designMode) return;
  try {
    
  const initPaintliBeforeAfter = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.plhBaReady === 'true') return;
    const input = root.querySelector('.plh-ba__range');
    if (!input) return;
    root.dataset.plhBaReady = 'true';

    const setSplit = (value) => {
      const next = Math.min(96, Math.max(4, Number(value)));
      root.style.setProperty('--plh-ba-split', `${next}%`);
      input.value = String(next);
      const before = root.querySelector('.plh-ba__tag--before');
      const after = root.querySelector('.plh-ba__tag--after');
      const beforeName = before ? before.textContent.trim() : 'Before';
      const afterName = after ? after.textContent.trim() : 'After';
      input.setAttribute(
        'aria-valuetext',
        `${beforeName} ${Math.round(next)}%, ${afterName} ${Math.round(100 - next)}%`
      );
    };

    const fromPointer = (event) => {
      const rect = root.getBoundingClientRect();
      if (!rect.width) return;
      setSplit(((event.clientX - rect.left) / rect.width) * 100);
    };

    root.addEventListener('pointerdown', (event) => {
      if (event.button !== 0) return;
      root.setPointerCapture(event.pointerId);
      fromPointer(event);
    });
    root.addEventListener('pointermove', (event) => {
      if (!root.hasPointerCapture(event.pointerId)) return;
      fromPointer(event);
    });
    input.addEventListener('input', () => setSplit(input.value));
    setSplit(input.value);
  };

  const initAllPaintliBeforeAfter = (scope) => {
    (scope || document).querySelectorAll('[data-plh-ba]').forEach(initPaintliBeforeAfter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllPaintliBeforeAfter());
  } else {
    initAllPaintliBeforeAfter();
  }
  document.addEventListener('shopify:section:load', (event) => {
    initAllPaintliBeforeAfter(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
